import React from 'react';
import PropTypes from 'prop-types';
import './MaterialIcon.css';

const MaterialIcon = ({
  icon,
  size = 24,
  className = '',
  onClick,
  fallback = null
}) => {
  if (!icon) {
    return null;
  }

  // Generate size class based on size prop
  const sizeClass = size !== 24 ? `material-icon-size-${size}` : '';
  const clickableClass = onClick ? 'material-icon-clickable' : '';

  const classes = [
    'material-symbols-outlined',
    'material-icon',
    sizeClass,
    clickableClass,
    className
  ].filter(Boolean).join(' ');

  return (
    <span
      className={classes}
      onClick={onClick}
      title={`${icon} icon`}
    >
      {icon}
    </span>
  );
};

MaterialIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func,
  fallback: PropTypes.node
};

export default MaterialIcon; 